import * as React from "react";

export type SortingDirections = "ASC" | "DESC" | "";

export class Order extends React.Component<{
    sorting: SortingDirections;
}, {}> {
    baseClass: string;
    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-order";
    }

    render() {
        const cls = this.baseClass +
            (this.props.sorting ? ` ${this.baseClass}--${this.props.sorting.toLowerCase()}` : "");
        return (
            <span className={cls}>
                {this.props.children}
            </span>
        );
    }
}